<template>
  <div>
    <div class="user-list__item" @click="handleClick" >
      <el-row>
        <el-col :span="24">
          <div class="user-list-item__name">
            {{ displayName }}
          </div>
          <div class="user-list-item__title">
            {{ title }}
          </div>
        </el-col>
        <!-- <el-col :span="10">
          <div class="choose-user-label">
            <span>
              {{ $t('chooseUserPage.chooseUserButtonText') }}
            </span>
          </div>
        </el-col> -->
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  props: {
    displayName: { type: String },
    title: { type: String },
  },
  methods: {
    handleClick() {
      this.$emit('onClick');
    },
  },
};
</script>
<style lang="stylus" scoped>
.user-list__item {
  border-bottom: solid 1px whitesmoke;
  padding: 20px 10px;
  &:hover {
    background-color: #dcdcdc33;
    cursor: pointer;
  }
  &:hover .choose-user-label {
    opacity: 1;
  }
}

.choose-user-label {
  opacity:0;
  color: #969696;
}

.user-list-item__name, .user-list-item__title {
  text-align: left;
}

.user-list-item__name {
  color: #2f2f2f;
}
.user-list-item__title {
  color: #8e8e8e;
}
</style>
